import { useState } from "react";
import Modal from "react-modal";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { Endpoints } from "../../Global/Endpoints";
import { useTranslation } from 'react-i18next';

Modal.setAppElement("#root");

export const FeedbackModal = ({ isOpen, onClose, onSave, feedback,
  setFeedback, feedbackConsent, setFeedbackConsent }) => {
  const { t } = useTranslation();

  const resetFields = () => {
    setFeedback("");
  };

  return (
    <div>
      <Modal
        isOpen={isOpen}
        onRequestClose={() => {
          resetFields();
          onClose();
        }}
        className="tracker-modal-content"
        overlayClassName="tracker-modal-overlay"
        shouldCloseOnOverlayClick={false}
        style={{
            content: {
            maxWidth: "500px",
            width: "90%",
            margin: "auto",
            height: "auto",
            minHeight: "unset",
            },
        }}
      >
        <h2 className="mb-5" style={{fontSize: "16px"}}>We take your feedback very seriously. <br /> Can you let us know what improvements would be helpful?</h2>

        <div className="model-form-wrapper">
          <div className="mb-4 row align-items-center switch-control-wrapper">
            <div className="mb-4 row">
                <label className="col-sm-12 model-form-label mt-2">Feedback</label>
                <div className="col-sm-12">
                <textarea
                    value={feedback}
                    onChange={(e) => {
                      setFeedback(e.target.value);
                    }}
                    placeholder="Enter feedback"
                    className="form-control win-form-control textarea-control mobile-view-important"
                    rows="4"
                    maxLength={100}
                />
                </div>
            </div>

            <div className="col-sm-12">
                <div className="form-check d-flex align-items-center">
                    <input
                        type="checkbox"
                        className="form-check-input radio-btn win-form-check-input mobile-view me-2"
                        id="feedbackConsent"
                        checked={feedbackConsent === "Y"}
                        onChange={() => setFeedbackConsent(feedbackConsent === "Y" ? "N" : "Y")}
                        style={{ marginTop: 0 }}
                    />
                    <label
                        className="form-check-label mb-0"
                        htmlFor="feedbackConsent"
                        style={{ fontSize: "14px" }}
                    >
                        I consent to being contacted about this feedback.
                    </label>
                </div>
        </div>
        </div>

          <div className="mb-4 row">
            <div className="col-sm-12">
              <button 
                onClick={() => {
                  resetFields(); 
                  onClose(); 
                }} 
                className="win-btn-secondary btn-w-180px model-popup-btn me-3 mb-3 mb-sm-0"
              >
                {t("Cancel")}
              </button>
              <button 
                onClick={() => {
                  onSave();
                }} 
                className="win-btn-primary btn-w-180px model-popup-btn"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export const FeedbackConsent = ({
  isOpen,
  onClose,
  deviceType,
  token,
  email
}) => {
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [feedbackStatus, setFeedbackStatus] = useState("");
  const [feedbackConsent, setFeedbackConsent] = useState("N");

  const saveFeedback = async ({
    feedbackAction,
    nextFeedbackStatus = feedbackStatus,
    nextFeedback = feedback,
    closeFeedbackModal = true,
  }) => {
    setLoading(true);
    const params = {
      EmailID: email,
      DeviceType: deviceType,
      FeedbackConsent: feedbackConsent,
      CallQuality: 0,
      NurseQuality: 0,
      FeedbackStatus: nextFeedbackStatus,
      Feedback: nextFeedback,
      FeedbackAction: feedbackAction,
    };
    try {
      await axios.post(
        Endpoints.SaveFeedback,
        `_Params=${encodeURIComponent(JSON.stringify(params))}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      if (closeFeedbackModal) {
        setShowFeedbackModal(false);
      }
    }
  };

  const handleFeedbackRating = async (status) => {
    onClose();
    setFeedbackStatus(status);
    await saveFeedback({
      feedbackAction: "Rating",
      nextFeedbackStatus: status,
      closeFeedbackModal: false,
    });
    setShowFeedbackModal(true);
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }

  // Consent modal
  return (
    <>
      <Modal
        isOpen={isOpen}
        onRequestClose={onClose}
        className="tracker-modal-content-c"
        overlayClassName="tracker-modal-overlay"
        shouldCloseOnOverlayClick={false}
        style={{width:"350px"}}
      >
       
        <p style={{ marginTop: "3rem", marginBottom: "3rem", textAlign: "center", fontSize:"1.2rem" }}>
          Do you love WIN patient portal?
        </p>
        <div className="mb-4 row justify-content-center">
            <div className="col-6 d-flex justify-content-center">
                <button
                className="win-btn-secondary model-popup-btn w-100"
                style={{ borderRadius: "24px", fontWeight: 600 }}
                onClick={() => handleFeedbackRating("No")}
                >
                No
                </button>
            </div>
            <div className="col-6 d-flex justify-content-center">
                <button
                className="win-btn-primary model-popup-btn w-100"
                style={{ borderRadius: "24px", fontWeight: 600 }}
                onClick={() => handleFeedbackRating("Yes")}
                >
                Yes
                </button>
            </div>
        </div>
      </Modal>
      <FeedbackModal 
        isOpen={showFeedbackModal} 
        onClose={() => {
            setShowFeedbackModal(false);
        }} 
        feedback={feedback}
        setFeedback={setFeedback}
        feedbackConsent={feedbackConsent}
        setFeedbackConsent={setFeedbackConsent}
        onSave={() => saveFeedback({ feedbackAction: "Feedback" })}
      />
    </>
  );
};
